import { render, staticRenderFns } from "./ac-groupcard.vue?vue&type=template&id=4bb1ecb0&"
import script from "./ac-groupcard.vue?vue&type=script&lang=js&"
export * from "./ac-groupcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports